import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { Rodeo } from '../../../model/rodeo';
import { RodeoEvent } from '../../../model/rodeoEvent';

import { RodeoEventSchedule } from '../../../model/rodeoEventSchedule';
import { RodeoEventService } from '../../../services/rodeoEvent.service';

@Component({
    selector: 'rodeo-setup',
    templateUrl: 'rodeo-setup.html'
})
export class RodeoSetupPage {
    setupStage: string = 'start';
    overallEventType: string = 'rodeo';

    selectedDisciplines: RodeoEvent[] = [];
    addedSchedules: RodeoEventSchedule[] = [];
    disciplineScheduleMapping: Map<number, string[]> = new Map();

    availableDisciplines: string[] = [];

    constructor(private rodeoEventService: RodeoEventService, private viewController: ViewController) {
        this.rodeoEventService.getEventTypes()
        .then( data => {
            this.availableDisciplines = data as string[];
        });
    }

    matchDisciplineType(a: string, b: string) {
        return a == b;
    }

    matchDisciplines(a: string, b: string) {
        return a == b;
    }

    goToEvents() {
        this.setupStage = 'events';

        if (this.addedSchedules.length == 0)
            this.addNewDiscipline();
    }

    addNewSchedule() {
        let newSchedule = new RodeoEventSchedule();
        newSchedule.id = Math.random() * 100;
        this.addedSchedules.push(newSchedule);
        this.disciplineScheduleMapping[newSchedule.id] = [];
    }

    addNewDiscipline() {
        let newRodeoEvent = new RodeoEvent();

        if (this.overallEventType == 'jackpot') {
            newRodeoEvent.singleDate = true;
            newRodeoEvent.drawFirstToEnterLastToCompete = true;
        }
            

        if (this.selectedDisciplines.length > 0) {
            newRodeoEvent.eventType = this.selectedDisciplines[this.selectedDisciplines.length - 1].eventType;
            newRodeoEvent.displayName = newRodeoEvent.eventType;
        }

        if (!newRodeoEvent.isRoughStock())
            newRodeoEvent.horseRequired = true;

        this.selectedDisciplines.push(newRodeoEvent);
    }

    updateDisciplineSchedules() {
        this.addedSchedules.push(new RodeoEventSchedule());
    }

    removeDiscipline(discipline: RodeoEvent) {
        this.selectedDisciplines = this.selectedDisciplines.filter(x => x != discipline);

        this.addedSchedules.forEach(schedule => {
            if (this.disciplineScheduleMapping[schedule.id])
                this.disciplineScheduleMapping[schedule.id] = this.disciplineScheduleMapping[schedule.id].filter(x => this.selectedDisciplines.some(y => y == x));
        })
    }

    goToSchedules() {
        this.setupStage = 'schedules';

        this.selectedDisciplines.forEach(discipline => {
            if (discipline.singleDate) {
                let newSchedule = new RodeoEventSchedule();
                newSchedule.id = Math.random() * 100;
                newSchedule.name = "Main";

                this.addedSchedules.push(newSchedule);
                this.disciplineScheduleMapping[newSchedule.id] = [];
                this.disciplineScheduleMapping[newSchedule.id].push(discipline.displayName);
            }
        })
    }

    updateDiscipline(index) {
        this.selectedDisciplines[index].displayName = this.selectedDisciplines[index].eventType;
    }

    createRodeo() {
        let newRodeo = new Rodeo();
        newRodeo.rodeoEvents = [];

        this.addedSchedules.forEach(schedule => {
            this.disciplineScheduleMapping[schedule.id].forEach(rodeoEventName => {
                schedule.id = 0;
                if (rodeoEventName == 'All') {
                    this.selectedDisciplines.forEach(rodeoEvent => {
                        rodeoEvent.schedules.push(schedule);
                    })
                } else {
                    this.selectedDisciplines.filter(x => x.displayName == rodeoEventName)[0].schedules.push(schedule);
                }
            })
        })

        this.selectedDisciplines.forEach(rodeoEvent => {
            if (this.overallEventType == 'jackpot') {
                rodeoEvent.preferencesAllowed = 0;
            }

            newRodeo.rodeoEvents.push(rodeoEvent);
        });

        this.viewController.dismiss(newRodeo)
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/rodeo-setup.ts